import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { FlatPageRouteControl } from "@app/components/FlatPageRouteControl";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { assetClassAnalysisAnalyzeForwardLookingAnalysisPages } from "@app/const/route.const";
import { AssetClassAnalysisSimulatedForwardProbabilities } from "./AssetClassAnalysisSimulatedForwardProbabilities";
export const AssetClassAnalysisForwardLookingAnalysis = memo(() => {
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="h2SSemiBold" sx={{ mt: 4 }}>
          Forward Looking Analysis
        </Typography>
      </Box>
      <FlatPageRouteControl
        tabs={[
          {
            url: assetClassAnalysisAnalyzeForwardLookingAnalysisPages.simulatedForwardProbabilities,
            label: "Simulated Forward Probabilities",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_SIMULATED_FORWARD_PROBABILITY,
            content: <AssetClassAnalysisSimulatedForwardProbabilities />,
          },
          {
            url: assetClassAnalysisAnalyzeForwardLookingAnalysisPages.correlations,
            label: "Correlations",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_CORRELATIONS,
            content: <div>todo</div>,
          },
        ]}
        sx={{ mt: 3 }}
      />
    </>
  );
});
